import { ExclamationTriangleIcon } from '@heroicons/react/24/solid';
import React from 'react';

export function ValidatorMessage(props: { message: React.ReactNode }) {
  return <div className="flex flex-row py-auto mt-1 max-w-400">
    <ExclamationTriangleIcon className="text-red-300 h-7 w-7 my-auto flex-shrink-0" />
    <div className="text-gray-800 my-1 ml-1">
      {props.message}
    </div>
  </div>
}